import React from "react";

const NavItemTemplate = ({
  handleClick,
  active,
  title,
  icon,
  buttonExpand,
  children,
  menuItemMainClass,
  disabled
}) => {
  return (
    <div className="menu-item">
      <div
        className={`menu-item-main ${menuItemMainClass || ""} ${
          active ? "active" : ""
        }`}
        onClick={() => handleClick()}
        style={disabled ? {cursor: "progress"} : {}}
      >
        <div className="icon">{icon}</div>
        <span className="text text-truncate ps-3">{title}</span>
        {buttonExpand}
      </div>
      {children}
    </div>
  );
};

export default NavItemTemplate;
